import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 90px;
  height: 90px;
  color: #c7c7c7;
`

const Recipients = ({ title = 'Recipient', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 90 90" title={title} {...rest}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="surveys-Results" transform="translate(-369.000000, -393.000000)" stroke="currentColor" strokeWidth="2">
        <g id="surveys-landing" transform="translate(-47.000000, -99.000000)">
          <g id="Survey-lists" transform="translate(356.000000, 241.000000)">
            <g id="recipients" transform="translate(49.000000, 151.000000)">
              <g id="icon_recipients" transform="translate(12.000000, 101.000000)">
                <path
                  d="M28,37.0438667 C26.6120348,34.068 23.6299995,32 20.1781026,32 L8.64775827,32 C3.87131312,32 0,35.9394667 0,40.8 L0,52.5333333 L5.76517218,55.4666667 L7.20646523,76 L23.0606887,76"
                  id="Shape"
                />
                <circle id="Oval" strokeLinecap="square" cx="15" cy="15" r="9" />
                <path
                  d="M60,37.0438667 C61.3879652,34.068 64.3700005,32 67.8218974,32 L79.3522417,32 C84.1286869,32 88,35.9394667 88,40.8 L88,52.5333333 L82.2348278,55.4666667 L80.7935348,76 L64.9393113,76"
                  id="Shape"
                />
                <circle id="Oval" strokeLinecap="square" cx="74" cy="15" r="9" />
                <path
                  d="M53,88 L35,88 L33.5,64.4210526 L26,62.9473684 L26,43.7894737 C26,37.2787368 31.373,32 38,32 L50,32 C56.627,32 62,37.2787368 62,43.7894737 L62,62.9473684 L54.5,64.4210526 L53,88 Z"
                  id="Shape"
                  strokeLinecap="square"
                />
                <circle id="Oval" strokeLinecap="square" cx="43.5" cy="11.5" r="11.5" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </StyledIcon>
)

Recipients.displayName = 'Recipients'
Recipients.needsWork = true
export default Recipients
